"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PFFKitError = void 0;
/**
 * An error thrown by PFFKit when something goes wrong.
 * @public
 */
class PFFKitError extends Error {
    constructor(code, message, underlyingError) {
        super(message);
        this.code = code;
        this.message = message;
        this.underlyingError = underlyingError;
    }
}
exports.PFFKitError = PFFKitError;
//# sourceMappingURL=error.js.map